// extracted by mini-css-extract-plugin
module.exports =  {"titleWithDetails":"SotNTOeZB2L_21WkpCXw","title":"F0PztZ161tMhKRzU6tDj","label":"ikCLhh9bVQSVAY0rroIK","carousel":"sJ79_iRdq_AP5guvhmLA"};